import React from "react";
import { SvgIcon } from "@material-ui/core";
import { colors } from "@teamrota/rota-design";

export const CloseIcon = props => {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.38306 4.72923L9.12056 7.46673C10.1987 8.54486 8.54869 10.2042 7.47056 9.11673L4.72369 6.38861L2.00494 9.12611C0.926814 10.2042 -0.732561 8.55423 0.354939 7.4761L3.09244 4.73861L0.354939 2.01986C-0.732561 0.932356 0.926814 -0.727019 2.00494 0.351106L4.72369 3.08861L7.46119 0.351106C8.53931 -0.727019 10.1987 0.922981 9.11119 2.00111L6.38306 4.72923Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const SaveIcon = props => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 39 39"
      style={{ width: "39px", height: "39px" }}
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.89772 4.11754e-05H31.5628L39 7.56313V34.0795C39.0027 34.7264 38.8778 35.3674 38.6326 35.9656C38.3874 36.5638 38.0267 37.1073 37.5714 37.5648C37.1161 38.0222 36.5751 38.3845 35.9797 38.6309C35.3843 38.8772 34.7463 39.0027 34.1024 39H4.89772C4.2538 39.0027 3.61574 38.8772 3.02034 38.6309C2.42493 38.3845 1.88397 38.0222 1.42865 37.5648C0.973334 37.1073 0.612674 36.5638 0.367478 35.9656C0.122282 35.3674 -0.00259852 34.7264 4.09839e-05 34.0795V4.9206C-0.00259852 4.27368 0.122282 3.63264 0.367478 3.03445C0.612674 2.43626 0.973334 1.89277 1.42865 1.43533C1.88397 0.977882 2.42493 0.615537 3.02034 0.369195C3.61574 0.122853 4.2538 -0.00261066 4.89772 4.11754e-05ZM10.2489 1.36686H28.7512C29.9303 1.36686 30.8373 2.27808 30.8373 3.37154V12.8482C30.8311 13.4021 30.6094 13.9316 30.2195 14.3233C29.8296 14.715 29.3026 14.9378 28.7512 14.944H10.2489C9.69753 14.9378 9.17049 14.715 8.7806 14.3233C8.39071 13.9316 8.16896 13.4021 8.16283 12.8482V3.37154C8.16283 2.27808 9.06981 1.36686 10.2489 1.36686ZM6.34888 19.4089H32.6512C33.1082 19.4089 33.5466 19.5913 33.8697 19.916C34.1929 20.2407 34.3745 20.6811 34.3745 21.1402V35.4463C34.3745 36.4486 33.6489 37.1776 32.6512 37.1776H6.34888C5.3512 37.1776 4.53492 36.4486 4.53492 35.4463V21.1402C4.53492 20.229 5.3512 19.4089 6.34888 19.4089Z"
          fill={colors.rotaOrange}
        />
        <path
          d="M27.2651 2.91602H22.7656V13.6237H27.2651V2.91602Z"
          fill={colors.rotaOrange}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="39" height="39" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
